// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dc440c25","453":"49ab5d40"}[chunkId] + ".chunk.js";
};